/**
 * Decide whether a submission-document upload should be recorded as a customer response.
 *
 * The backend only allows a non-response upload past the Draft stage, which is why every upload used
 * to be sent as `is_response=true`. ERM-12397 lets an internal user add a document in Pre-Review, and
 * such a document is WCG's, not an answer to a request - sending `true` would leave it looking like an
 * outstanding customer response.
 *
 * The exception is deliberately narrow: only an internal user, only in Pre-Review, and only when the
 * upload answers no document-request to-do. Every other flow - including any Draft upload - keeps the
 * previous `true` so existing behaviour is untouched.
 */
export function isResponseUpload({
  hasTaskIds,
  isInternal,
  currentStage,
}: {
  hasTaskIds: boolean;
  isInternal: boolean;
  currentStage: string;
}): boolean {
  const isInternalPreReviewAdd =
    isInternal && currentStage === 'qc_check' && !hasTaskIds;

  return !isInternalPreReviewAdd;
}
